import { Badge } from "@rarible_int/anaconda_ui_components"

interface Props {
  count: number
}

export function Counter(props: Props) {
  return props.count ? (
    <Badge variant="secondary" className="px-1 text-foreground/60 text-sm">
      {props.count}
    </Badge>
  ) : null
}
